
import { useStore } from '@/store'
import { defineComponent, ref, onMounted } from 'vue'
import { computed } from 'vue'
import bodySettings from '@/settings/body-settings.json'
import FormOption from '@/components/Form/FormOption.vue'
import FormColorPicker from '@/components/Form/FormColorPicker.vue'
import { ConfigurationActionTypes } from '@/store/modules/configuration/action-types'
import { ColorpickerActionTypes } from '@/store/modules/colorpicker/action-types'
import Analytics from '@/singletons/analytics'
import FormScrollableTab from '@/components/Abstract/FormScrollableTab.vue'
import StageDeterminerService from '@/services/page/stage-determiner.service'

export default defineComponent({
  name: 'FormBody',
  components: {
    FormScrollableTab,
    FormOption,
    FormColorPicker
  },
  props: {
    index: Number
  },
  setup() {
    let stageDeterminer = new StageDeterminerService()
    const store = useStore()
    const configName = ref('configBodyId')
    const colorpicker = ref("#2e2e2e")
    const showColorPicker = ref(false)
    const config = computed(() => store.getters[configName.value])
    const options = computed(() => bodySettings.fullorderColors)

    onMounted(() => {
      if (stageDeterminer.isColorpickerVisible()) {
        showColorPicker.value = true
      }
    })

    const onClick = (option: any) => {
      store.dispatch(ConfigurationActionTypes.SET_CONFIG_BODY, option.id)
      Analytics.instance.sendBodyEvent(option.id)

      colorpicker.value = option.value || "#2e2e2e";
    }

    const onColorPickerUpdate = (val) => {
      store.dispatch(ColorpickerActionTypes.SET_COLORPICKER_BODY, val)
    }

    return {
      config,
      configName,
      bodySettings,
      colorpicker,
      onClick,
      onColorPickerUpdate,
      options,
      showColorPicker
    }
  }
})
